import apiHelpers from '@/utils/api'
import { AlrContainer } from '@/models/response/AlrContainer'
import { AloIdentity } from '@/models/alo/AloIdentity'
import { AxiosPromise } from 'axios'
import { AloUserIdentity } from '@/models/alo/AloUserIdentity'
import { AloForgottenPass } from '@/models/alo/AloForgottenPass'
import { AloUser } from '@/models/alo/AloUser'
import { TemplateMail } from '@/enum/TemplateMail'

export default {
  authenticate(user: AloUserIdentity): AxiosPromise<AlrContainer<AloUser>>  {
    return apiHelpers.apiCall({ 
        url:'/webapi/Authenticate', 
        method:'POST', 
        data: user,
        transformResponse: [function (data: string) {                              
          return JSON.parse(data) as AlrContainer<AloUser>
        }]
     })
  },  
  autolog(key: string): AxiosPromise<AlrContainer<AloUser>>  {
    return apiHelpers.apiCall({ 
        url:'/webapi/Authenticate/autolog', 
        method:'GET', 
        params:{key},
        transformResponse: [function (data: string) {                              
          return JSON.parse(data) as AlrContainer<AloUser>
        }]
     })
  }, 
  getAuthenticatedUser(): AxiosPromise<AlrContainer<AloUser>>  {
    return apiHelpers.apiCall({ 
      url: '/webapi/Authenticate', 
      method: 'GET',
      transformResponse: [function (data: string) {          
        return JSON.parse(data) as AlrContainer<AloUser>
      }] 
    })
  },
  logout(): AxiosPromise<AlrContainer<string>>  {
    return apiHelpers.apiCall({ 
      url: '/webapi/Authenticate', 
      method: 'DELETE',
      transformResponse: [function (data: string) {          
        return JSON.parse(data) as AlrContainer<string>
      }] 
    })
  },  
  forgetPassword(data:AloForgottenPass): AxiosPromise<AlrContainer<string>>  {   
    data.mtpId = TemplateMail.ForgotPassword
    return apiHelpers.apiCall({ 
      url: '/webapi/Authenticate/forgotten', 
      method: 'POST',
      data,
      transformResponse: [function (data: string) {          
        return JSON.parse(data) as AlrContainer<string>
      }] 
    })
  },

  changePassword(data:AloForgottenPass): AxiosPromise<AlrContainer<string>>  {
    return apiHelpers.apiCall({ 
      url: '/webapi/Authenticate', 
      method: 'PUT',
      data,
      transformResponse: [function (data: string) {          
        return JSON.parse(data) as AlrContainer<string>
      }] 
    })
  },

  createPassword(data:AloForgottenPass): AxiosPromise<AlrContainer<string>>  {
    data.mtpId = TemplateMail.ChangePassword
    return apiHelpers.apiCall({ 
      url: '/webapi/Authenticate/forgotten', 
      method: 'PUT',
      data,
      transformResponse: [function (data: string) {          
        return JSON.parse(data) as AlrContainer<string>
      }] 
    })
  },

  createAccount(data:AloForgottenPass): AxiosPromise<AlrContainer<AloUser>>  {        
    return apiHelpers.apiCall({ 
      url: '/webapi/Authenticate/create-account', 
      method: 'POST',
      data,
      transformResponse: [function (data: string) {          
        return JSON.parse(data) as AlrContainer<AloUser>
      }] 
    })
  }
  
}